import { cn } from '@/lib/utils';

export function DeltaPill({ value, suffix = '' }) {
	// Null / undefined signals "no comparable previous period" — the handler
	// returns this when the prior window has zero baseline. Showing "+100%"
	// against a non-existent baseline misled retailers in trial.
	if (value === null || value === undefined) {
		return (
			<div className="inline-flex w-fit items-center gap-1.5 rounded-full bg-info-soft px-2.5 py-1 text-xs font-semibold text-info-soft-foreground">
				New
			</div>
		);
	}
	const numeric = Number(value) || 0;
	const up = numeric >= 0;
	return (
		<div
			className={cn(
				'inline-flex w-fit items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold',
				up ? 'bg-success-soft text-success-soft-foreground' : 'bg-destructive/10 text-destructive'
			)}
		>
			{up ? '+' : ''}
			{numeric}%{suffix ? ` ${suffix}` : ''}
		</div>
	);
}
